<bn-web-ui-card
  class="mt-3"
  heading="Select the Perfect WAF Profile for Your Website"
  >Our tailored WAF profiles are designed for each platform to minimize false positives while delivering maximum security.</bn-web-ui-card
>
<div class="my-4 pr-4">
  <bn-web-ui-tabs
    class="mr-4 shield-setup-platform-profiles__tabs"
    itemStyle="primary"
    [activeTab]="0"
    [hasBorder]="false"
    [tabItems]="profileCategories"
    (activeTabChange)="onActiveTabChange($event)" />
</div>
<bn-web-ui-card heading="{{ selectedTab.title }}">
  <div class="row g-2 mt-2">
    @if (isLoading) {
      @for (item of [].constructor(6); track $index) {
        <div class="shield-setup-platform-profiles__platform col-12 col-sm-6 col-md-4">
          <ng-container *ngTemplateOutlet="skeletonItem" />
        </div>
      }
    } @else {
      @for (profile of filteredProfiles; track profile) {
        <div class="shield-setup-platform-profiles__platform col-12 col-sm-6 col-md-3">
          <div
            class="shield-setup-platform-profiles__platform__wrapper h-100 d-flex justify-content-space-between flex-column"
            [ngClass]="{ 'shield-setup-platform-profiles__platform__wrapper--active': profile.id === selectedProfileId }"
            (click)="onProfileSelect(profile.id)">
            <div>
              @if (profile.id === selectedProfileId) {
                <div class="shield-setup-platform-profiles__platform__icon-container">
                  <fa-icon
                    class="shield-setup-platform-profiles__platform__check-icon"
                    icon="check" />
                </div>
              }
              <div class="shield-setup-platform-profiles__platform__content my-2">
                <img
                  alt="{{ profile.name }}"
                  class="shield-setup-platform-profiles__platform__content--image p-3"
                  src="{{ profile.imageUrl }}" />
              </div>
              <h3 class="shield-setup-platform-profiles__platform__title mt-4">{{ profile.name }}</h3>
            </div>
          </div>
        </div>
      }
    }
  </div>
</bn-web-ui-card>
<ng-template #skeletonItem>
  <div class="shield-setup-platform-profiles__platform__wrapper h-100 d-flex justify-content-space-between flex-column">
    <div>
      <h3 class="shield-setup-platform-profiles__platform__title">
        <ngx-skeleton-loader
          appearance="line"
          count="1"
          [theme]="{
            'height.px': 19,
            'margin-bottom': 0,
            'width.%': 100,
            overflow: 'hidden',
          }" />
      </h3>
      <div class="shield-setup-platform-profiles__platform__description mt-2">
        <ngx-skeleton-loader
          appearance="line"
          count="1"
          [theme]="{
            'height.px': 44,
            'margin-bottom': 0,
            'width.%': 100,
            overflow: 'hidden',
          }" />
      </div>
    </div>
    <div class="d-flex flex-grow-1">
      <ngx-skeleton-loader
        appearance="line"
        class="d-inline-flex"
        count="1"
        [theme]="{
          'align-self': 'flex-end',
          'height.px': 28,
          'margin-top': '5px',
          'margin-bottom': 0,
          'width.px': 85,
          overflow: 'hidden',
        }" />
    </div>
  </div>
</ng-template>
